"use client"

import { createContext, useContext, useEffect, useState } from "react"

const LocaleContext = createContext({ locale: "es", setLocale: () => {} })

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState("es")

  useEffect(() => {
    const saved = localStorage.getItem("preferredLocale")
    if (saved) setLocale(saved)
  }, [])

  const change = (l) => {
    setLocale(l)
    localStorage.setItem("preferredLocale", l)
  }

  return <LocaleContext.Provider value={{ locale, setLocale: change }}>{children}</LocaleContext.Provider>
}

export const useLocale = () => useContext(LocaleContext)
